import FuelConsum from "../FuelConsum"

class FuelVariables{

    public fuel : FuelConsum = new FuelConsum()
    public FCvoyage: number = 0
    public FCboiler: number = 0
    public FCothers: number = 0
    public FCelectrical : number = 0

    public typeFCelec : {[key: string]: string} = {}
    public canMonitorElecConsumption : string = ""
    public selectedSFOC: {[key: string]: string} = {}
    public personalizedSFOC : number = 0
    public SFOC : number = 0
    public FCs: number = 0

    public reefer : number = 0
    public daysSea : number = 0
    public daysPort : number = 0
    public numContainers : number = 0
    public nocArrival : number = 0
    public nocDeparture : number = 0
    public cooling : number = 0
    public discharge : number = 0

}

class NeobuqCarbonData{

    public shipStructuralImprovements : boolean = false;
    public shipChemicalTanker : boolean = false;
    public shipLightTransport : boolean = false;
    public shipTankerType : {[key: string]: string} = {}

    public arrayFuelVariables : Array<FuelVariables> = new Array<FuelVariables>()
    public travelDistance : number = 0

    public numFuels : number = 0
}

export default NeobuqCarbonData